module.exports = __webpack_public_path__ + "img/computer-classic.451e9311.svg";